import { gql } from '@reverbdotcom/commons/src/gql';
import React from 'react';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { COUNTRY_CODES } from '../constants';
import { withUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';

function shouldSkipTrendingSearches(ownProps) {
  // used for saved searches recommended content
  if (!ownProps.user?.loggedOut) { return false; }
  if (ownProps.user?.countryCode !== COUNTRY_CODES.US) { return true; }
  return false;
}

export const TRENDING_SEARCHES_QUERY = gql(`query TrendingSearchesQuery(
  $limit: Int
  $shouldSkipListings: Boolean!
) {
  trendingSearches(input: {
    nResults: $limit,
  }) {
    trendingSearches {
      query
      categoryUuid
      categorySlug
      queryParams
      listings @skip(if: $shouldSkipListings) {
        _id
        id
        state
        slug
        images(input: {
          type: "Product",
          scope: "photos",
          transform: "card_square"
          count: 4
        }) {
          _id
          source
        }
      }
    }
  }
}`);

export default function withTrendingSearches<IProps>(
  Component: React.ComponentType<IProps>,
): React.ComponentType<IProps> {
  const requestConfig = {
    skip: ownProps => shouldSkipTrendingSearches(ownProps),
    options: (ownProps) => {
      return {
        ssr: false,
        variables: {
          limit: ownProps.limit || 6,
          shouldSkipListings: ownProps.shouldSkipListings || false,
        },
      };
    },
    props({ data, ownProps }) {
      const { trendingSearches, loading } = data;

      const props = {
        ...ownProps,
        trendingSearches: trendingSearches?.trendingSearches || [],
        loading,
      };
      return props;
    },
  };
  return withUserContext(withGraphql(TRENDING_SEARCHES_QUERY, requestConfig)(Component)) as React.ComponentType<IProps>;
}
